import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=15efcf65&"
import script from "./PortalFooter.vue?vue&type=script&lang=ts&"
export * from "./PortalFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports